import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscriptions-actions',
  templateUrl: './subscriptions-actions.component.html',
  styleUrls: ['./subscriptions-actions.component.css']
})
export class SubscriptionsActionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
